import { useState, useEffect } from "react";
import { getSavedFiles } from "../api/fileService";
import { attachAuthToken } from "../api/apiClient";

const FILES_CACHE_KEY = "savedFilesCache";
const CACHE_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hrs

export const useSavedFiles = (auth) => {
  const [savedFiles, setSavedFiles] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(true);

  useEffect(() => {
    const cached = sessionStorage.getItem(FILES_CACHE_KEY);

    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const isExpired = Date.now() - timestamp > CACHE_DURATION_MS;

      if (!isExpired) {
        setSavedFiles(data);
        setLoadingFiles(false);
        return;
      } else {
        // remove stale cache
        sessionStorage.removeItem(FILES_CACHE_KEY);
      }
    }

    // Skip if no token yet
    if (!auth?.user?.id_token) {
      setLoadingFiles(false);
      return;
    }

    attachAuthToken(auth);

    getSavedFiles()
      .then((data) => {
        setSavedFiles(data);
        sessionStorage.setItem(
          FILES_CACHE_KEY,
          JSON.stringify({ data, timestamp: Date.now() })
        );
      })
      .catch((err) => {
        console.error("Failed to load files", err);
      })
      .finally(() => {
        setLoadingFiles(false);
      });
  }, [auth]);

  return { savedFiles, loadingFiles, setSavedFiles };
};
